import { render } from "./Playground.vue?vue&type=template&id=319849e3&ts=true"
import script from "./Playground.vue?vue&type=script&lang=ts"
export * from "./Playground.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\vue_test\\form-gpt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__